/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import styleInject from 'style-inject';

var css_248z = ".List-module_scrollShadow__zRynM {\n  --scroll-shadow-bg: var(--iap-colors-bg-default);\n  background:\n    linear-gradient(var(--scroll-shadow-bg) 33%, transparent),\n    linear-gradient(transparent, var(--scroll-shadow-bg) 66%) 0 100%,\n    radial-gradient(farthest-side at 50% 0, rgba(34, 34, 34, 0.5), rgba(0, 0, 0, 0)),\n    radial-gradient(farthest-side at 50% 100%, rgba(34, 34, 34, 0.5), rgba(0, 0, 0, 0)) 0 100%;\n  background-color: transparent;\n  background-repeat: no-repeat;\n  background-attachment: local, local, scroll, scroll;\n  background-size:\n    100% 15px,\n    100% 15px,\n    100% 2px,\n    100% 2px;\n}\n";
var classes = {"scrollShadow":"List-module_scrollShadow__zRynM"};
styleInject(css_248z);

export { classes as default };
